import { useTheme } from "@/src/styles/theme-provider";
import { Pressable, Text } from "react-native";

type ColorModeButtonProps = Readonly<{
  label: string;
  icon: React.ElementType;
  isActive: boolean;
  onPress: () => void;
}>;

const ColorModeButton = ({ label, icon: Icon, isActive, onPress }: ColorModeButtonProps) => {
  const { themeVars } = useTheme();

  return (
  <Pressable
    onPress={onPress}
    className={`flex-1 items-center py-3 px-2 rounded-xl border active:opacity-90 web:hover:border-ash-1
    ${isActive ? "border-primary bg-primary-1 hover:bg-primary-2" : "border-ash-3 bg-ash hover:bg-ash-3"}
  `}
    style={{ gap: 6 }}
  >
    <Icon
      size={20}
      variant={isActive ? "Bold" : "Linear"}
      color={themeVars["--color-primary-default"] as string}
    />
    <Text className={`text-xs ${isActive ? "font-semibold text-primary" : "text-ash-2"}`}>
      {label}
    </Text>
  </Pressable>
  );
};

export default ColorModeButton;
